export default __webpack_public_path__ + "static/media/Triton room.6aafffc2.jpg";